import { TrendingUp } from "lucide-react";
import { IncomeRow } from "@/components/IncomeControls";

// Displays every expected income occurrence in a flat, chronologically-
// sorted list. Users think about their money in date order ("what's coming
// in next?"), not by source ("show me all Husband's Paycheck"), so grouping
// by source added a mental hop that ran counter to how the app is used.
//
// Each occurrence renders as an IncomeRow with the source name shown
// prominently — all existing edit / mark-received / delete actions on the
// row still work exactly the same. Rows share the same rounded-2xl +
// border-2 shell as Step-2 buckets so the visual grammar stays consistent
// across all three steps.
export default function GroupedIncomeList({ items, onChanged, testIdPrefix = "ppf-grouped-income" }) {
  const sorted = [...items].sort((a, b) => {
    const da = a.expected_date || "";
    const db = b.expected_date || "";
    return da.localeCompare(db);
  });

  return (
    <div className="space-y-2 py-2 px-3" data-testid={`${testIdPrefix}-flat`}>
      {sorted.map((inc) => (
        <div
          key={inc.id}
          className="rounded-2xl border-2 border-[#D8CFB9] bg-white/80 overflow-hidden"
          data-testid={`${testIdPrefix}-row-${inc.id}`}
        >
          <div className="flex items-center gap-3 px-4 py-2">
            <span
              className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-[#DDE9D8] text-[#1F6B2E]"
              aria-hidden="true"
            >
              <TrendingUp size={16} strokeWidth={2} />
            </span>
            <div className="flex-1 min-w-0">
              <IncomeRow inc={inc} onChanged={onChanged} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
